import React from 'react';
import { map, isEmpty, noop, find, filter, get, isUndefined } from 'lodash';
import classnames from 'classnames';

// import { isVisible } from 'resolvers/getVisibleEntities';

import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { BLANK_VALUE_SYMBOL } from 'constants/common';

export const AddressInfo = ( props ) => {

    const { address, type, actions, enableSelection } = props;
    
    // get display title
    const displayTitle = filter( [ address.line1, address.line2, address.city, address.state, address.zip ], Boolean ).join( ', ' );

    // get Default action
    const setDefault = find( actions, { name: 'setDefault' } );
    
    // check if set Default action is allowed
    const canSetDefault = get( address, 'actionsVisibility.setDefault', false );

    // const canDelete = get( address, 'actionsVisibility.delete', false );
    // const canEdit = get( address, 'actionsVisibility.edit', false );
    const isDefault = get( address, 'flags.isDefault', false );

    const isActivated = get( address, 'flags.isActivated', true );

    // const canInactivate = get( address, 'actionsVisibility.inactivate', false );
    // const canActivate = get( address, 'actionsVisibility.activate', false );

    // edit actions
    const footerActions = filter( actions, action => {
        return 'setDefault' !== action.name && ( isActivated ?  'activate' !== action.name : 'inactivate' !== action.name );
    } );

    const className = classnames( 'ui-member-address-card', {
            'ui-member-address-card--selected': ( get( address, 'selected', false ) && props.checkoutShipping ),
            'ui-member-address-card--inactivated': !isActivated
        }
    );
    
    const defaultSectionClass = classnames( 'ui-member-address-card__details__head__default', {
            'ui-member-address-card__details__head__default--highlight': isDefault,
            'ui-member-address-card__details__head__default--disabled': ! canSetDefault,
            'ui-member-address-card__details__head__default--inactivated': !isActivated
        }
    );

    const titleClassName = classnames( 'ui-member-address-card__details__head__title', {
        'ui-member-address-card__details__head__title--action': enableSelection
    } );

    const bodyClassName = classnames( 'ui-member-address-card__details__body', {

        // 'ui-member-address-card__details__body--has-footer': !isEmpty( footerActions )
    } );

    // used for able or disable Edit Action
    // const editClassName = classnames( 'ui-member-address-card__footer__action', {
    //     'ui-member-address-card__footer__action--disabled': !canEdit
    // } );

    // // used for able or disable Delete Action
    // const deleteClassName = classnames( 'ui-member-address-card__footer__action', {
    //     'ui-member-address-card__footer__action--disabled': !canDelete
    // } );

    // // used for able or disable Delete Action
    // const inactivateClassName = classnames( 'ui-member-address-card__footer__action', {
    //     'ui-member-address-card__footer__action--disabled': !canInactivate
    // } );

    // // used for able or disable Delete Action
    // const activateClassName = classnames( 'ui-member-address-card__footer__action', {
    //     'ui-member-address-card__footer__action--disabled': !canActivate
    // } );

    let isDefaultVisible = false;
    if ( !isEmpty( get( props, 'defaultDescription' ) ) ) {
        isDefaultVisible = true;
    }

    return (
        <div className={ className }>
            
            <div className='ui-member-address-card__details'>
                <div className='ui-member-address-card__details__head'>

                    {/* card type */}
                    <div className={ titleClassName } onClick={ () => enableSelection && isActivated ? props.onSelectActionClick( { address } ) :noop } >
                        
                        { enableSelection && isActivated &&(
                            <RadioBox selected={ get( address, 'selected', false ) } />
                        ) }
                        { type }
                    </div>

                    {
                        setDefault ? (
                            <div className={ defaultSectionClass } onClick={ () => {
                                ( canSetDefault && ! isDefault && isActivated ) ? props.onSetDefaultClick( { address } ): noop;
                            } } >
                                { getLabel( get( setDefault, 'title', {} ) ) }
                            </div>
                        ) : null
                    }
                </div>
                
                {/* address */}
                <div className={ bodyClassName }>
                    { displayTitle }
                    {
                        isDefault && isDefaultVisible ? (
                            <div className='ui-member-address-card__details__head__default__info' >
                                <div className='ui-member-address-card__details__head__default__info__icon'>
                                    <Icon name='info' width='14' height='14' fill='#ffffff' />
                                </div>
                                <div className='ui-member-address-card__details__head__default__info__description'>
                                    { getLabel( props.defaultDescription.description ) }
                                </div>
                            </div>
                        ) : null
                    }
                </div>

            </div>
           
           {/* actions */}
           { !isEmpty( footerActions ) && (
                <div className='ui-member-address-card__footer'>
                    { map( footerActions, action => {

                        const isActionVisible = get( address.actionsVisibility, action.name, false );

                        const footerClassName = classnames( 'ui-member-address-card__footer__action', {
                            'ui-member-address-card__footer__action--disabled': !isActionVisible || ( !isActivated && 'inactivate' !== action.name && 'activate' !== action.name )
                        } );
                        return(
                            <div className={ footerClassName }  key={ action.name }
                            onClick={ () => {
                                    if( 'edit' === action.name && isActionVisible && isActivated ) {

                                        props.onAddEditActionClick( { value: action, type: 'edit', item: address } );

                                    } else if( 'delete' === action.name && isActionVisible ) {

                                        props.onDeleteActionClick( { address } );
                                        
                                    } else if( 'activate' === action.name && isActionVisible ) {

                                        props.onActivateActionClick( { address } );
                                        
                                    } else if( 'inactivate' === action.name && isActionVisible ) {
                                        
                                        props.onInactivateActionClick( { address, selected: get( address, 'selected', false ) } );
                                        
                                    }
                                }
                            }>
                                {  'edit' === action.name && (
                                    <Icon id={ 'edit' } fill={ isActionVisible ? THEME.themeColorPrimary2 : '#7a7a7a' } height={ 16 } width={ 16 } />
                                ) }

                                {  'delete' === action.name && (
                                    <Icon id={ 'delete' } fill={ isActionVisible ? THEME.themeColorPrimary2 : '#7a7a7a' } height={ 16 } width={ 16 } />
                                ) }

                                {  'activate' === action.name && (
                                    <Icon id={ 'activateCheck' } fill={ isActionVisible ? THEME.themeColorPrimary2 : '#7a7a7a' } height={ 16 } width={ 16 } />
                                ) }

                                {  'inactivate' === action.name && (
                                    <Icon id={ 'inactivateCheck' } fill={ isActionVisible ? THEME.themeColorPrimary2 : '#7a7a7a' } height={ 16 } width={ 16 } />
                                ) }
                                
                                <div className= 'ui-member-address-card__footer__action__text'>
                                    { getLabel( action.title ) }
                                </div>
                            </div>
                        );
                    } ) }
                </div>
           ) }
            
        </div>
    );
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberAddEditAddress as memberAddEditAddress } from 'ui/views/widgets/memberAddEditAddress';
 *
 * // render
 * <memberAddEditAddress propName='propValue'/>
 */
export const memberAddEditAddress = ( props ) => {

    const { addresses, options, addAction = {},  modifyActions, title = {}, className, addActionClassName = null, enrollToEpostJourney = false } = props;

    const _addActionClassName = classnames( 'ui-memeber-add-edit-address__width', addActionClassName );
    const parentClass = classnames( 'ui-memeber-add-edit-address', className );

    const isAddActionAllowed = enrollToEpostJourney ? isEmpty( addresses ) : true;
    const shippingLabel = get(props.shippingDescription, "description",{})

    return (
        <div className={ parentClass }>

            {/* widget title */}
            {! isEmpty( title ) && (
                
                <div className='ui-memeber-add-edit-address__header'>
                    <Icon id={ 'address' } />
                    <div className='ui-memeber-add-edit-address__header__title'>
                        { getLabel( title ) }
                    </div>
                    <div className="ui-input-field__editable__label__asterisk">*</div>
                </div>
                
                
            ) }
            {  !isEmpty(shippingLabel) && (
                <span className='ui-memeber-add-edit-address__header__subtitle'>
                {getLabel(shippingLabel)}
            </span>
            )}

            <div className='ui-member-card'>

            {/* check if add Action is allowed */}
            { ! isEmpty( addAction ) && isAddActionAllowed && (
                <div className={ _addActionClassName } onClick={ () => props.onAddEditActionClick( { type: 'add', value: addAction } ) }>
                    <Icon id={ 'add' } />
                    <div className='ui-memeber-add-edit-address__add__title'>{ getLabel( addAction.title ) }</div>
                </div>
            ) }
            
            {/* address card view */}
            { map( addresses, item => {

                const addresstype = find( options.addressType, { value: item.type } );

                return (
                    <AddressInfo
                        key={ item.id || item.tempId }
                        address={ item }
                        type={ ! isUndefined( addresstype ) ? getLabel( addresstype.title ): BLANK_VALUE_SYMBOL }
                        actions={ modifyActions }
                        onSetDefaultClick={ props.onSetDefaultClick }
                        onSelectActionClick={ props.onSelectActionClick }
                        onDeleteActionClick={ props.onDeleteActionClick }
                        enableSelection={ props.enableSelection }
                        onAddEditActionClick={ props.onAddEditActionClick }
                        defaultDescription= { get( props, 'defaultDescription', {} ) }
                        onInactivateActionClick = { props.onInactivateActionClick }
                        onActivateActionClick = { props.onActivateActionClick }
                    />
                );

            } ) }

            {/* info card view */}
            {
                !isEmpty( props.infoCard ) ? (
                    <div className={ `${ parentClass }__infocard` }>
                        <div className={ `${ parentClass }__infocard__icon` }>
                            <Icon name='infoRed' width='14' height='14' fill='#ffffff' />
                        </div>
                        <div className={ `${ parentClass }__infocard__description` }>
                            { getLabel( get( props, 'infoCard.description' ) ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
        </div>
        
    );
};

// set display name
memberAddEditAddress.displayName = 'memberAddEditAddress';

// set default props
memberAddEditAddress.defaultProps = {};

// prop types
memberAddEditAddress.propTypes = {};

/*************************************** */

export const AddressCardPreloader = () => {
    return(
        <div className='ui-memeber-add-edit-address-preloader__cards__card'>
            <div className='ui-memeber-add-edit-address-preloader__cards__card__header'>
                <div className='ui-memeber-add-edit-address-preloader__cards__card__header__radio'></div>
                <div className='ui-memeber-add-edit-address-preloader__cards__card__header__title'></div>
            </div>
            <div className='ui-memeber-add-edit-address-preloader__cards__card__body'>
                <div className='ui-memeber-add-edit-address-preloader__cards__card__body__line'></div>
                <div className='ui-memeber-add-edit-address-preloader__cards__card__body__line'></div>
            </div>
            <div className='ui-memeber-add-edit-address-preloader__cards__card__footer'>
                <div className='ui-memeber-add-edit-address-preloader__cards__card__footer__action'></div>
                <div className='ui-memeber-add-edit-address-preloader__cards__card__footer__action'></div>
            </div>
        </div>
    );
};

export const memberAddEditAddresspreloader = ( props ) => {

    const { hideTitle = false } = props;
    return (
        <div className='ui-memeber-add-edit-address-preloader'>

            { ! hideTitle && (
                <div className='ui-memeber-add-edit-address-preloader__title'>
                    <div className='ui-memeber-add-edit-address-preloader__title__icon'></div>
                    <div className='ui-memeber-add-edit-address-preloader__title__value'></div>
                </div>
            ) }
            
            <div className='ui-memeber-add-edit-address-preloader__cards'>
                <div className='ui-memeber-add-edit-address-preloader__cards__add'>
                    <div className='ui-memeber-add-edit-address-preloader__cards__add__icon'></div>
                    <div className='ui-memeber-add-edit-address-preloader__cards__add__title'></div>
                </div>
                { map( [ 1, 2 ], item => {
                    return (
                        <AddressCardPreloader key={ item } />
                    );
                } ) }
            </div>
        </div>
    );
};

// set display name
memberAddEditAddresspreloader.displayName = 'memberAddEditAddresspreloader';

// set default props
memberAddEditAddresspreloader.defaultProps = {};

// prop types
memberAddEditAddresspreloader.propTypes = {};
